var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{staticClass:"image-with-fallback",attrs:{"src":_vm.currentSrc,"alt":_vm.alt,"loading":"lazy"},on:{"error":_vm.onError}})
}
var staticRenderFns = []

export { render, staticRenderFns }